import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkblockService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/workblocks`;

  constructor(private http: HttpClient) { }
  
  workblockTask(request: Boo.Workblocks.Models.TaskWorkblockRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/WorkblockTask`, request);
  }
  
  workblockTaskType(request: Boo.Workblocks.Models.TaskTypeWorkblockRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}/WorkblockTaskType`, request);
  }

  retentionWorkblockCustomer(customerId: number, note: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/RetentionWorkblockCustomer`, {
        customerId: customerId,
        note: note
    });
  }

  getReasons(): Observable<Boo.Workblocks.Models.WorkblockReason[]> {
    return this.http.get<Boo.Workblocks.Models.WorkblockReason[]>(`${this.baseUrl}/reasons`);
  }

  hasWorkblockForTaskOfTaskType(customerId: number, taskTypeId: Boo.Objects.Enums.TaskTypeEnum): Observable<boolean> {
    const params = new HttpParams()
      .set('customerId', customerId)
      .set('taskTypeId', taskTypeId);

    return this.http.get<boolean>(`${this.baseUrl}/hasWorkblockForTaskOfTaskType`, { params: params });
  }
}
